export default "__VITE_ASSET__Bvyjx_I3__";